module.exports = __webpack_public_path__ + "static/img/2.9c1a2bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/2.png
// module id = wDXc
// module chunks = 0